import { SimpleBlock } from 'ui-builder';
import React from 'react';
import styles from './ExternalLinksList.module.scss';

export function LinkStatusWidget(props: {
  isConflicting: boolean
  conflictingTitle: string
}) {
  return (
    <SimpleBlock
      className={`${styles.status} ${props.isConflicting ? styles.conflict : ''}`}
      title={props.isConflicting ? props.conflictingTitle : undefined}
    >

    </SimpleBlock>
  );
}
